window.__forceSmoothScrollPolyfill__ = true; // eslint-disable-line no-underscore-dangle
require('smoothscroll-polyfill').polyfill();

$(() => {
  $("body.front a[href*='#']").on('click', (e) => {
    e.preventDefault();
    document.querySelector(e.target.hash).scrollIntoView({ behavior: 'smooth' });
  });
});